"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.audioChunkSchema = void 0;
const zod_1 = require("zod");
exports.audioChunkSchema = zod_1.z.object({
    kind: zod_1.z.literal("audio:chunk"),
    // The audio format
    format: zod_1.z.enum(["mp3", "ogg"]),
    // The audio encoded in base64
    audioBase64: zod_1.z.string(),
    // Since chunks of audios can be generated out of order we need to keep them ordered
    position: zod_1.z.number(),
    // How long to sleep between audios
    sleep: zod_1.z.number(),
    // Transcript of the audio
    partialSentence: zod_1.z.string(),
    // Indicates if this is a last chunk
    isLastChunk: zod_1.z.boolean(),
});
//# sourceMappingURL=audioChunk.js.map